module.exports = __webpack_public_path__ + "static/media/design-highlights.1c0b3fcb.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/Hashing/design-highlights.png
// module id = 176
// module chunks = 0